module.exports = __webpack_public_path__ + "img/join-bg-mobile.d58c0c12.jpg";